import React, { useState, useEffect, setGlobal, useGlobal, useCallback, useRef } from 'reactn';
import PropTypes from 'prop-types';
import Checkbox from '@material-ui/core/Checkbox';

import { makeStyles, withStyles } from '@material-ui/core/styles';

import { Button } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import IconClose from '@material-ui/icons/Close';
import IconDelete from '@material-ui/icons/Delete';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import IconEdit from '@material-ui/icons/Edit';
import IconSend from '@material-ui/icons/Send';
import axios from "axios";

import LoadingOverlay from 'react-loading-overlay';

import { toast_success, toast_warning } from '../api/api';

import { navigatePage, useOnClickOutside } from '../lib/lib';

import Pagination from '../component/Pagination';
import DialogSignCreate from '../component/DialogSignCreate';
import DialogStampCreate from '../component/DialogStampCreate';
import TableTab from '../component/TableTab';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    tableWrapper: {
        overflowX: 'scroll',
        [theme.breakpoints.up('sm')]: {
            overflowX: 'unset',
        },
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    tableToolbar: {
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            alignItems: 'center',
        },
    },
    button_create_template: {
        borderWidth: 2,
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
        backgroundColor: 'white',
        marginRight: 15,
        paddingLeft: 6,
        paddingRight: 6,
        fontWeight: 'bold',
        fontSize: '1.1em',
        transition: 'all .3s',
        whiteSpace: 'nowrap',
        '&:hover': {
            borderWidth: 2,
            backgroundColor: theme.palette.primary.main,
            color: 'white',
        },
    },
    searchPaper: {
        border: '1px solid #ccc',
        boxShadow: 'none',
        display: 'flex',
        transition: 'all .4s',
        width: '70%',
        '&:hover, &:focus-within': {
            width: '100%',
        },
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
    },
    iconButton: {
        padding: 7,
        color: theme.palette.secondary.main,
    },
    iconButtonDel: {
        padding: 7,
        color: '#999',
    },
    tableRowTemplateName: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: 50,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 300,
        cursor: 'pointer',
        // border: '1px solid grey',
        [theme.breakpoints.up('sm')]: {
            minWidth: 200,
            maxWidth: 440,
        },
    },
}));

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const headCells = [
    { id: 'sign', numeric: false, disablePadding: false, label: '사인' },
    { id: 'created_date', numeric: true, disablePadding: false, label: '생성시간' },
    // { id: 'updated_date', numeric: true, disablePadding: false, label: '업데이트 시간' },
];
const headCellsStamp = [
    { id: 'stamp', numeric: false, disablePadding: false, label: '도장'},
    { id: 'created_date', numeric: true, disablePadding: false, label: '생성시간'}
]


function EnhancedTableHead(props) {
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                    <Checkbox
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={numSelected === rowCount && rowCount > 0}
                        onChange={onSelectAllClick}
                        inputProps={{ 'aria-label': 'select all desserts' }}
                    />
                </TableCell>
                {headCells.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        style={headCell.numeric ? { width: 200 } : {}}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={order}
                            onClick={createSortHandler(headCell.id)}
                            style={{
                                fontSize: '1.4em',
                            }}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

function EnhancedTableHeadStamp(props) {
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = property => event => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                <TableCell padding="checkbox">
                    <Checkbox
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={numSelected === rowCount && rowCount > 0}
                        onChange={onSelectAllClick}
                        inputProps={{ 'aria-label': 'select all desserts' }}
                    />
                </TableCell>
                {headCellsStamp.map(headCell => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'default'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        style={headCell.numeric ? { width: 200 } : {}}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={order}
                            onClick={createSortHandler(headCell.id)}
                            style={{
                                fontSize: '1.4em',
                            }}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHeadStamp.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const StyledButton = withStyles(theme => ({
    root: {
        backgroundColor: theme.palette.secondary.main,
        color: 'white',
        width: 190,
        height: 50,
        border: 'none',
        borderRadius: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 'bold',
        fontSize: '1.2em',
        '&:hover': {
            backgroundColor: theme.palette.secondary.dark,
        },
    },
}))(Button);

function Entity(props) {
	const classes = useStyles();

	const [sToken] = useGlobal('sToken');
    const [sApiUrl] = useGlobal('sApiUrl');

	const [sSearchQuery, setSearchQuery] = useState('');
	const [sQuery, setQuery] = useState('');
	const [rows, setRows] = useState([]);

	const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('created_date');
	const [selected, setSelected] = React.useState([]);
	
	const [page, setPage] = React.useState(0);
	const [rowsPerPage] = React.useState(10);

	const [openPopper, setOpenPopper] = React.useState(false);
	const [anchorEl, setAnchorEl] = React.useState(null);
    const [docToDel, setDocToDel] = React.useState({ id: -1, template_name: '' });
    const [openPopperEdit, setOpenPopperEdit] = React.useState(false);
    const [docToEdit, setDocToEdit] = React.useState({ id: -1, template_name: '' });

    const [bFileUploaderOpen, setFileUploaderOpen] = React.useState(false);

    const [bDialogSignCreate, setDialogSignCreate] = useState(false);
    const [bDialogStampCreate, setDialogStampCreate] = useState(false);
	
    const [bLoading, setLoading] = React.useState(false);

    const [selectedTab, setSelectedTab] = useState('sign');
    const [bCreated, setCreated] = useState(false);
    
    const fetchData = useCallback((tab) => {
        const sUrl = `/${sApiUrl}/docUserSign?tab=`+tab;
        setLoading(true);
        axios.create({
            headers: {
                Authorization: `Bearer ${sToken}`,
            }
        }).get(sUrl)
        .then(res => {
            setLoading(false);
            switch (res.data.status) {
                case '000':
                    if (res.data.entity !== undefined && res.data.entity !== null) {
                        if (res.data.entity.length > 0) {
                            setRows(res.data.entity.map(item => {
                                return {
                                    id: item.signIdx,
                                    signImgIdx: item.signImgIdx,
                                    filename: item.docUserSignImg.systemFileName,
                                    created_date: item.regDate,
                                };
                            }));
                        } else {
                            setRows([]);
                        }
                    }
                    break;
                default:
                    toast_warning(res.data.message);
            }
        }).catch(err => {
            setLoading(false);
            toast_warning(`System error: ${JSON.stringify(err)}`);
        });
        console.log(rows.signImgIdx);
        console.log(rows.stampImgIdx);
    }, [sApiUrl, sToken]);

    useEffect(() => {
        console.log("selectedTab:::"+selectedTab);
        fetchData(selectedTab);
        setPage(0);
    }, [selectedTab]);

    useEffect(() => {
        console.log("selectedTab:::"+selectedTab);
        fetchData(selectedTab);
        setPage(0);
    }, [bCreated]);

    const ref = useRef();
    
    const refDel = useRef();

    useOnClickOutside(ref, () => setOpenPopperEdit(false));

    useOnClickOutside(refDel, () => setOpenPopper(false));

    function handleChangePage(newPage) {
        setPage(newPage);
    }

	function handleRequestSort(event, property) {
        if (property === 'sign') {
            return;
        }
        const isDesc = orderBy === property && order === 'desc';
        setOrder(isDesc ? 'asc' : 'desc');
        setOrderBy(property);
    }

    function handleSelectAllClick(event) {
        if (event.target.checked) {
            const newSelecteds = rows.map(n => n.id);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
	}

	function handleClick(event, id) {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    }

	const isSelected = id => selected.indexOf(id) !== -1;

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

	return (
		<div
			style={{
				width: '100%',
			}}
		>
			<div className={classes.tableWrapper}>
                <div className={classes.tableToolbar}>
                    <div style={{ display: 'inline-block', marginRight: 10 }}>
                        <Button
                            variant="outlined"
                            color="secondary"
                            className={classes.button_create_template}
                            onClick={() => {
                                setCreated(false);
                                setDialogSignCreate(true);
                            }}
                        >
                            사인 생성하기
                        </Button>
                        <Button
                            variant="outlined"
                            color="secondary"
                            className={classes.button_create_template}
                            onClick={() => {
                                setCreated(false);
                                setDialogStampCreate(true);
                            }}
                        >
                            도장 생성하기
                        </Button>
                    </div>
                </div>
                <TableTab 
                    activeTab = {selectedTab}
                    onChange={(selectTab) => {                        
                        setSelectedTab(selectTab);
                    }}
                />
                <LoadingOverlay
                    active={bLoading}
                    spinner
                    text='Loading...'
                    styles={{
                        overlay: {
                            position: 'fixed',
                            height: '100vh',
                            width: '100%',
                            top: 0,
                            left: 0,
                            display: 'flex',
                            textAlign: 'center',
                            fontSize: '1.2em',
                            color: '#FFF',
                            background: 'rgba(0,0,0,0.7)',
                            zIndex: 800,
                            transition: 'opacity 500ms ease-in',
                            opacity: 1,
                        }
                    }}
                >
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size={'medium'}
                    >
                        {selectedTab === 'sign' ? 
                            <EnhancedTableHead
                                classes={classes}
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={rows.length}
                            /> :
                            <EnhancedTableHeadStamp
                                classes={classes}
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={rows.length}
                            />
                        }
                        <TableBody>
                            {stableSort(rows, getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {
                                    const isItemSelected = isSelected(row.id);
                                    const labelId = `enhanced-table-checkbox-${index}`;

                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            key={row.id}
                                            selected={isItemSelected}
                                        >
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    checked={isItemSelected}
                                                    inputProps={{ 'aria-labelledby': labelId }}
                                                    onChange={event => handleClick(event, row.id)}
                                                />
                                            </TableCell>
                                            <TableCell component="th" id={labelId} scope="row" padding="none">
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        paddingLeft: 14,
                                                    }}
                                                >
                                                    <div
                                                        className={classes.tableRowTemplateName}
                                                    >
                                                        {typeof row.signImgIdx !== 'undefined' ?
                                                            <img src={`${sApiUrl}/docUserSignImg/download/${row.signImgIdx}`} style={{ height: 40 }}/> :
                                                            ''
                                                        }
                                                    </div>
                                                    <IconButton
                                                        className={classes.iconButtonDel}
                                                        aria-label="delete"
                                                        onClick={e => {
                                                            setOpenPopperEdit(false);
                                                            setAnchorEl(e.currentTarget);
                                                            setDocToDel(row);
                                                            if (anchorEl === e.currentTarget) {
                                                                setOpenPopper(!openPopper);
                                                            } else {
                                                                setOpenPopper(true);
                                                            }
                                                        }}
                                                    >
                                                        <IconDelete />
                                                    </IconButton>
                                                </div>
                                            </TableCell>
                                            <TableCell align="right">{row.created_date}</TableCell>
                                            {/* <TableCell align="right">{row.updated_date}</TableCell> */}
                                        </TableRow>
                                    );
                                })}
                            {emptyRows > 0 && rows.length > 0 && (
                                <TableRow style={{ height: 51 * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                    <Popper open={openPopperEdit} anchorEl={anchorEl} placement="bottom-start" transition>
                        {({ TransitionProps }) => (
                            <Fade {...TransitionProps} timeout={350}>
                                <Paper
                                    ref={ref}
                                    style={{
                                        width: 270,
                                        height: 100,
                                        padding: 20,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        alignItems: 'stretch',
                                    }}
                                >
                                    <div>
                                        <Typography className={classes.typography} style={{ fontWeight: 'bold', textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                            {docToEdit.template_name}
                                        </Typography>
                                    </div>
                                    <List>
                                        <ListItem
                                            button
                                            onClick={() => {
                                            }}
                                        >
                                            <ListItemIcon className={classes.listItemIcon}><IconEdit /></ListItemIcon>
                                            <ListItemText className={classes.listItemText} primary={'Edit'} />
                                        </ListItem>
                                    </List>
                                </Paper>
                            </Fade>
                        )}
                    </Popper>
                    <Popper open={openPopper} anchorEl={anchorEl} placement="bottom" transition>
                        {({ TransitionProps }) => (
                            <Fade {...TransitionProps} timeout={350}>
                                <Paper
                                    ref={refDel}
                                    style={{
                                        width: 270,
                                        height: 150,
                                        padding: 20,
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between',
                                        alignItems: 'stretch',
                                    }}
                                >
                                    <Typography className={classes.typography} style={{ textAlign: 'center' }}>삭제하시겠습니까?</Typography>
                                    <Typography className={classes.typography} style={{ fontWeight: 'bold', textAlign: 'center', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {docToDel.template_name}
                                    </Typography>
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'space-around',
                                            // padding: 10,
                                        }}
                                    >
                                        <IconButton
                                            className={classes.iconButtonDel}
                                            aria-label="yes"
                                            onClick={() => {
                                                console.log(docToDel);
                                                // setLoading(true);
                                                axios.create({
                                                    headers: {
                                                        Authorization: `Bearer ${sToken}`,
                                                    }
                                                }).delete(`/${sApiUrl}/docUserSign/${docToDel.id}`)
                                                    .then(res => {
                                                        switch (res.data.status) {
                                                            case '000':
                                                                toast_success('삭제되었습니다.');
                                                                setOpenPopper(false);
                                                                fetchData(selectedTab);
                                                                break;
                                                            default:
                                                                toast_warning(res.data.message);
                                                        }
                                                    }).catch(err => {
                                                        // setLoading(false);
                                                        toast_warning(`System error: ${JSON.stringify(err)}`);
                                                    });
                                            }}
                                        >
                                            <IconDelete />
                                        </IconButton>
                                        <IconButton
                                            className={classes.iconButtonDel}
                                            aria-label="no"
                                            onClick={() => {
                                                setOpenPopper(false);
                                            }}
                                        >
                                            <IconClose />
                                        </IconButton>
                                    </div>
                                </Paper>
                            </Fade>
                        )}
                    </Popper>
                </LoadingOverlay>
            </div>
            <Pagination
                page={page}
                count={rows.length}
                rowsPerPage={rowsPerPage}
                onChangePage={handleChangePage}
                style={{
                    marginBottom: 50,
                }}
            />
            <DialogSignCreate
                open={bDialogSignCreate}
                bLoading={bLoading}
                // docToEdit={docToEdit}
                onClose={() => {
                    setDialogSignCreate(false);
                    //document.getElementById('sign_tab').click();
                    console.log('1!!!');
                    setSelectedTab('sign');
                    setCreated(true);
                }}
                onClickCancel={() => {
                    // setDialogSignProgressInformation(false);
                }}
            />
            <DialogStampCreate
                open={bDialogStampCreate}
                bLoading={bLoading}
                // docToEdit={docToEdit}
                onClose={() => {
                    setDialogStampCreate(false);
                    console.log('2!!!');
                    //document.getElementById('stamp_tab').click();
                    setSelectedTab('stamp');
                    setCreated(true);
                }}
                onClickCancel={() => {
                    // setDialogSignProgressInformation(false);
                }}
            />
		</div>
	);
}

export default Entity;